import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import withModal from '../../../../../../components/global/modal/withModal';
import useVirtualPageView from '../../../../../../apps/pro/services/analytics/useVirtualPageView';

const propTypes = {
  className: PropTypes.string,
  onDiscard: PropTypes.func,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  message: PropTypes.node.isRequired,
};

const AccountCardDismissConfirm = ({
  className,
  onDiscard,
  onConfirm,
  onCancel,
  message,
}) => {
  useVirtualPageView({
    title: 'Create a card - Discard card',
    path: '/discard',
  });

  const [loading, setLoading] = useState(false);
  const classes = classNames({
    'account-card-dismiss-modal': true,
    'alert-modal-content': true,
    [className]: !!className,
  });

  return (
    <Fragment>
      <div className={classes}>
        <p className="text-extra-bold">Are you sure?</p>
        {message}
      </div>

      <div
        className={classNames({
          'account-card-dismiss-modal-actions': true,
          'is-loading': loading,
        })}
      >
        {onDiscard && (
          <button
            onClick={async () => {
              setLoading(true);
              await onDiscard();
              setLoading(false);
            }}
            className="btn-account-card-discard"
          >
            Discard card
          </button>
        )}

        {onConfirm && (
          <button onClick={onConfirm} className="btn-account-card-save">
            Save draft
          </button>
        )}

        {onCancel && (
          <button onClick={onCancel} className="btn-account-card-cancel">
            Stay here
          </button>
        )}
      </div>
    </Fragment>
  );
};

AccountCardDismissConfirm.propTypes = propTypes;

export default withModal(AccountCardDismissConfirm, {
  hideHeader: true,
  dismissible: false,
  size: 'xs',
  className: 'alert-modal',
  overlayClassName: 'alert-modal-overlay',
  shouldCloseOnOverlayClick: false,
});
